<template>
  <div class="marketing-section ma-0 pa-0">
    <v-row>
      <v-col cols="12" class="marketing-section-gradient" style="height:75px">&nbsp;</v-col>
      <v-col cols="12" class="marketing-section-arrow text-center">
        <v-img class="text-center mx-auto" width="350px" height="50px" src="/marketing-arrow.png"></v-img>
      </v-col>
      <v-col cols="12" md="6" :class="($vuetify.breakpoint.mdAndUp ? 'text-right ' : 'text-center ') + 'marketing-section-content'">
        
          <template v-if="imageFirst">
            <div class="d-block">
            <p><v-img :class="($vuetify.breakpoint.mdAndUp ? 'text-right ml-auto' : 'text-center mx-auto')" :max-width="maxWidth" :src="image"></v-img></p>
            </div>
          </template>
          <template v-else>
            <div class="d-inline-block">
            <span :class="($vuetify.breakpoint.mdAndUp ? 'ml-auto' : 'mx-auto')">
            <p :class="($vuetify.breakpoint.mdAndUp ? 'text-left ' : 'text-center ') + 'text-h4 font-weight-bold'" :style="'max-width:' + maxWidth">{{title}}</p>
            <p :class="($vuetify.breakpoint.mdAndUp ? 'text-left ' : 'text-center ') + 'text-subtitle-1 grey--text text--darken-1'" :style="'max-width:' + maxWidth">{{content}}</p>
            </span>
            </div>
          </template>          

      </v-col>
      <v-col cols="12" md="6" :class="($vuetify.breakpoint.mdAndUp ? 'text-left ' : 'text-center ') + 'marketing-section-content'">        
          <template v-if="imageFirst">
            <div class="d-inline-block">
            <span :class="($vuetify.breakpoint.mdAndUp ? 'mr-auto' : 'mx-auto')">
            <p :class="($vuetify.breakpoint.mdAndUp ? 'text-left ' : 'text-center ') + 'text-h4 font-weight-bold'" :style="'max-width:' + maxWidth">{{title}}</p>
            <p :class="($vuetify.breakpoint.mdAndUp ? 'text-left ' : 'text-center ') + 'text-subtitle-1 grey--text text--darken-1'" :style="'max-width:' + maxWidth">{{content}}</p>
            </span>
            </div>
          </template>
          <template v-else>
            <div class="d-block">
            <p><v-img :class="($vuetify.breakpoint.mdAndUp ? 'text-left mr-auto' : 'text-center mx-auto')" :max-width="maxWidth" :src="image"></v-img></p>
            </div>
          </template>

      </v-col>  
    </v-row>  
  </div>
</template>
<script>
export default {
  name: 'MarketingSection',
  props: {
    image: {
      type: String,
      description: 'Image path'
    },
    imageFirst: {
      type: Boolean,
      description: 'Display the image first or last',
      default: false
    },
    maxWidth: {
      type: String,
      description: 'Max width of the columns',
      default: '600px'
    },
    title: {
      type: String,
      description: 'Marketing title',
      default: ''
    },
    content: {
      type:String,
      description: 'Marketing content',
      default: ''
    }    
  }
}
</script>
<style lang="scss" scoped>
.marketing-section {
  width:100%;  
}
.marketing-section-gradient {
  width:100%;
  padding: 0px 0px 0px 0px;
  margin: 12px 0px 0px 0px;
  background-image: linear-gradient(white, #E6F6FF)
}
.marketing-section-arrow {
  width:100%;
  padding: 0px 0px 12px 0px;
  margin: 0px 0px 12px 0px;
}
</style>